const Logo = () => <span className="brackets" />;

export default Logo;
